
const BASE = 'aresLoan-mbBanking.products.loansAndMortgages.productContracting.aresLoanContracting.mbLegalViewer.';

export default {
  BASE,
  MODAL_TITLE: `${BASE}modalTitle`,
  MODAL_CONTINUE_BUTTON: `${BASE}modalNavigationContinueButton`,
  MODAL_CANCEL_BUTTON: `${BASE}modalNavigationCancelLink`,
  PDF_VIEWER_TITLE: `${BASE}modalDescription`,
  PDF_VIEWER_FOOTER: `${BASE}modalIneDescription`,
};
